<a
  [queryParams]="valueOrNull(item.queryParams)"
  [routerLinkActiveOptions]="item.routerLinkActiveOptions"
  [routerLink]="item.routerLink!"
  class="link"
  routerLinkActive="active">
  <ng-content />
</a>
